import { GridColumnProps } from '@progress/kendo-react-grid'
import { isDealsWalletTransactionReference } from 'api/Clients/Types/DealDto'
import { dealsColumns as brokerageDealsColumns } from 'routes/Brokerage/Deals/columns'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const dealsColumns: GridColumn[] = brokerageDealsColumns.filter(
  (x) => !isDealsWalletTransactionReference(x.field)
)
